/**
 * Loading / error / empty / no-data states for the comparison chart panel.
 * For Media Devoted | Created By Ciro Autiero
 */

import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';

type ChartStateVariant = 'loading' | 'error' | 'empty' | 'no-data';

const MESSAGES: Record<ChartStateVariant, string> = {
  loading: 'Loading comparison…',
  error: "Couldn't load the comparison.",
  empty: 'Select a metric to chart.',
  'no-data': 'No data for these ranges.',
};

export function CompareChartState({
  variant,
  onRetry,
}: {
  variant: ChartStateVariant;
  onRetry?: () => void;
}) {
  return (
    <div
      className={cn(
        'flex min-h-[240px] w-full flex-col items-center justify-center gap-2 rounded-lg border bg-card text-sm text-muted-foreground',
        variant === 'loading' && 'animate-pulse',
      )}
    >
      <span>{MESSAGES[variant]}</span>
      {variant === 'error' && onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </div>
  );
}

export default CompareChartState;
